module.exports = __webpack_public_path__ + "img/hacienda-resort-2.10f1c828.jpg";